import React, { useEffect, useContext, useState } from 'react';
import PlannerFormStyles from './PlannerForm.styled';
import { getGAClientId } from '../../../utils/config';
import DatePicker from 'react-datepicker';
import TextField from '../../../components/Shared/SmokeyTransitional/components/TextField/TextField';
import DropDownList from 'pubweb-smokey/dist/components/DropDownList/DropDownList';
import ChevronDwnSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/chevron-dwn.svg';
import completedFormIcon from '../../../images/portal/completedFormIcon.svg';
import ctaPlannerBlob from '../../../images/portal/ctaPlannerBlob.svg';
import { Link } from 'react-router-dom';
import {
  Button,
  Typography,
  CTAPlannerCard,
  TextInput,
} from 'dx-sdk/build/components';
import { getUTMParametersFromSessionCache } from '../../../components/Shared/SmokeyTransitional/utils/utils';
import {
  formatDealerName,
  formatPhoneNumberFromNumber,
} from 'pubweb-smokey/dist/utils/formatters';
import { DXAccountContext } from '../../../contexts/DXAccountContext';
import { fireSegmentEvent } from '../../../utils';

export const PlannerForm = ({ dealer, homes, showPlannerForm }) => {
  const dxContext = useContext(DXAccountContext);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [submissionLoading, setSubmissionLoading] = useState(false);
  const [phone, setPhone] = useState('');
  const [fName, setFName] = useState('');
  const [lName, setLName] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [fNameError, setFNameError] = useState('');
  const [lNameError, setLNameError] = useState('');
  const [apptDate, setApptDate] = useState({ value: null, error: null });
  const [apptTime, setApptTime] = useState({ value: null, error: null });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formError, setFormError] = useState(null);

  const [updatedUser, setUpdatedUser] = useState({
    userId: null,
    firstName: '',
    lastName: '',
    phone: '',
    zipcode: '',
    preferredPronouns: '',
    preferredContactMethod: [],
    preferredContactTime: [],
  });

  const submissionStored = dxContext?.state?.plannerFormIsSaved;

  const getMinScheduleVisitDate = () => {
    // min available date is the day after today (disregard current time)
    const currentDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );

    return currentDate.getDay() == 5
      ? currentDate.addDays(3)
      : currentDate.addDays(2);
  };

  const isAvailableScheduleVisitDay = (date) => {
    const day = date.getDay();
    return day !== 0;
  };

  const isSelectableScheduleVisitDate = (date) => {
    return (
      date >= getMinScheduleVisitDate() && isAvailableScheduleVisitDay(date)
    );
  };

  const DatepickerCustomInput = ({ value, onClick }) => (
    <TextField
      textFieldStyle="primary"
      label="Preferred Date"
      value={value}
      note={apptDate.error}
      onClick={onClick}
      icon={ChevronDwnSvg}
      errorMessage={apptDate.error}
    />
  );

  let utmParams;
  try {
    utmParams = getUTMParametersFromSessionCache();
  } catch (error) {
    utmParams = {};
  }

  function formatPhoneNumber(value) {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  const handlePhoneChange = (v) => {
    const formattedPhoneNumber = formatPhoneNumber(v);
    setPhone(formattedPhoneNumber);
  };

  const formatDate = (date) => {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [month, day, year].join('/');
  };

  useEffect(() => {
    const phoneFormatRegex =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    const phoneValid = phoneFormatRegex.test(phone);
    if (!phoneValid || !fName || fName == '' || !lName || lName == '') {
      setSubmitDisabled(true);
    } else {
      setSubmitDisabled(false);
    }

    if (phoneValid) {
      setPhoneError('');
    }
    if (fName) {
      setFNameError('');
    }
    if (lName) {
      setLNameError('');
    }
  }, [phone, fName, lName]);

  const saveForm = () => {
    const phoneRegex =
      /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    const phoneValid = phoneRegex.test(phone);
    if (apptDate.value && !apptTime.value) {
      setApptTime({ value: null, error: 'Please select a preferred time.' });
      return null;
    }
    if (apptTime.value && !apptDate.value) {
      setApptDate({ error: 'Please select a preferred date.' });
      return null;
    }
    if (phoneValid && fName && lName) {
      setPhoneError('');
      setFNameError('');
      setLNameError('');
      setSubmitDisabled(true);
      setSubmissionLoading(true);

      const formData = {
        Email: dxContext?.state?.account?.email || '',
        FirstName: fName || dxContext?.state?.account?.firstName || '',
        LastName: lName || dxContext?.state?.account?.lastName || '',
        Phone: phone || dxContext?.state?.account?.phone || '',
        Zip: dxContext?.state?.account?.zipcode || '',
        MyHomeAccountId:
          dxContext?.state?.account?.identityProviderUserId || '',
        PreferredContactMethod: '',
        PreferredContactTime: '',
        PreferredContactMethod:
          dxContext?.state?.account?.preferredContactMethod &&
          dxContext?.state?.account?.preferredContactMethod.length > 0
            ? dxContext?.state?.account?.preferredContactMethod[0]
            : '',
        PreferredContactTime:
          dxContext?.state?.account?.preferredContactTime?.join(',') || '',
        PreferredAppointmentDate: apptDate?.value
          ? formatDate(apptDate.value)
          : null,
        PreferredAppointmentTime: apptTime?.value || null,
        Beds: dxContext?.state?.account?.profile?.preferredBeds || 0,
        Baths: dxContext?.state?.account?.profile?.preferredBaths || 0,
        PlanToBuyMonth:
          `${dxContext?.state?.account?.profile?.targetMoveDateMonth}` || 0,
        PlanToBuyYear:
          parseInt(
            `${dxContext?.state?.account?.profile?.targetMoveDateYear}`
          ) || 0,
        BuyerSituation:
          dxContext?.state?.account?.profile?.buyerSituation || '',
        DownPayment: 0,
        FavoriteFeatures:
          dxContext?.state?.account?.profile?.likedFeatures.map(
            (f) => f.name
          ) || [],
        FavoriteModels:
          dxContext?.state?.favorites?.map((m) => `${m?.modelNumber}`) || [],
        Land: dxContext?.state?.account?.profile?.hasLand
          ? 'Has Land'
          : 'Needs Land',
        BudgetConfidence:
          dxContext?.state?.account?.profile?.budgetConfidence || '',
        PurchaseStrategy:
          dxContext?.state?.account?.profile?.fundingSource || '',
        LandType: dxContext?.state?.account?.profile?.landType || '',
        PreApproved:
          dxContext?.state?.account?.profile?.fundingSource == 'pre_approved'
            ? true
            : false,
        PreApprovalAmount:
          dxContext?.state?.account?.profile?.fundingSource == 'pre_approved'
            ? dxContext?.state?.account?.profile?.budget
            : 0,
        Budget: dxContext?.state?.account?.profile?.budget || 0,
        SquareFeet: 0,
        TopFavoriteHome: '',
        LandZip: `${dxContext?.state?.account?.profile?.landZip}`,
        LotNumber: dealer?.lotNumber || 0,
        DealerNumber: dealer?.dealerNumber || '',
        WrittenTextMessageConsent: true,

        MarketingMeta: {
          OriginWebURL: window?.location?.href || '',
          OriginWebApp: 'clayton-retail-website',
          OriginWebPageType: 'clayton-myhome-account',
          OriginWebFormType: 'lead-form',
          OriginWebFormCategory: apptDate?.value
            ? 'myhome-account-lead-schedule'
            : 'myhome-account-lead',
          OriginWebCampaign: '',
          UtmSource: utmParams.utm_source || '',
          UtmMedium: utmParams.utm_medium || '',
          UtmCampaign: utmParams.utm_campaign || '',
          UtmTerm: utmParams.utm_term || '',
          UtmContent: utmParams.utm_content || '',
          GAClientId: getGAClientId() || '',
          PubWebLeadId: '',
          DXClientId: '',
          GoogleClickId: '',
          BingClickId: '',
          FacebookClickId: '',
        },
      };

      dxContext?.actions?.leadFormSubmit(
        formData,
        setFormSubmitted,
        setFormError,
        setSubmitDisabled,
        setSubmissionLoading
      );

      if (
        (dxContext?.state?.account?.phone &&
          dxContext?.state?.account.phone !== phone) ||
        (dxContext?.state?.account?.firstName &&
          dxContext?.state?.account.firstName !== fName) ||
        !dxContext?.state?.account?.firstName ||
        (dxContext?.state?.account?.lastName &&
          dxContext?.state?.account.lastName !== lName) ||
        !dxContext?.state?.account?.lastName
      ) {
        const infoUpdate = {
          ...updatedUser,
          ['phone']: phone,
          ['firstName']: fName,
          ['lastName']: lName,
        };
        dxContext?.actions?.updateAccountRetail(infoUpdate);
      }
    } else {
      const errorScrollElement = document.getElementById('error-scroll');
      if (!fName || fName === '' || !lName || lName === '' || !phoneValid) {
        if (errorScrollElement) {
          errorScrollElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }

      if (!fName || fName === '') {
        setFNameError('Please enter your first name');
      }
      if (!lName || lName === '') {
        setLNameError('Please enter your last name');
      }
      if (!phoneValid) {
        setPhoneError('Please enter a valid 10 digit number');
      }
      return null;
    }
  };

  useEffect(() => {
    if (dxContext?.state?.account && !updatedUser.userId) {
      setUpdatedUser({
        userId: dxContext?.state?.account.userId,
        firstName: dxContext?.state?.account.firstName,
        lastName: dxContext?.state?.account.lastName,
        phone: dxContext?.state?.account.phone,
        zipcode: dxContext?.state?.account.zipcode,
        preferredPronouns: dxContext?.state?.account.preferredPronouns,
        preferredContactMethod:
          dxContext?.state?.account.preferredContactMethod,
        preferredContactTime: dxContext?.state?.account.preferredContactTime,
      });
      if (dxContext?.state?.account?.phone && !phone) {
        setPhone(dxContext?.state?.account?.phone);
      }
      if (dxContext?.state?.account?.firstName && !fName) {
        setFName(dxContext?.state?.account?.firstName);
      }
      if (dxContext?.state?.account?.lastName && !lName) {
        setLName(dxContext?.state?.account?.lastName);
      }
    }
  }, [dxContext?.state?.account]);

  return (
    <PlannerFormStyles>
      <div className="completed-cta">
        <div className="container">
          {!submissionStored && !formSubmitted && showPlannerForm && (
            <CTAPlannerCard
              accentImg={{
                src: completedFormIcon,
                alt: 'completed planner icon',
              }}
              heading="Ready to make the next move?"
              description={
                'We hope the planner has helped you feel more prepared to take the next step in your home buying journey. If you are done making edits and ready to move forward, submit your information and a home consultant will reach out.'
              }
              chip="You've completed your planner!"
              backgroundColor="#352269"
              backgroundImg={{
                src: ctaPlannerBlob,
                alt: 'blob',
              }}
              secondaryComponent={
                <form id="error-scroll">
                  <Typography component={'h3'} variant="h3">
                    Submit your planner details!
                  </Typography>
                  <div className="name-wrap">
                    <div>
                      <p className="form-label">First Name*</p>
                      <TextInput
                        color="#352269"
                        backgroundColor="white"
                        fullwidth
                        variant="fill"
                        name="compactOne"
                        type="number"
                        value={fName}
                        note={fNameError}
                        handlers={{
                          onChange: (v) => setFName(v),
                        }}
                        componentsProps={{
                          Input: {
                            maxlength: '40',
                          },
                        }}
                      />
                    </div>
                    <div>
                      <p className="form-label">Last Name*</p>
                      <TextInput
                        color="#352269"
                        backgroundColor="white"
                        fullwidth
                        variant="fill"
                        name="compactOne"
                        type="number"
                        value={lName}
                        note={lNameError}
                        handlers={{
                          onChange: (v) => setLName(v),
                        }}
                        componentsProps={{
                          Input: {
                            maxlength: '50',
                          },
                        }}
                      />
                    </div>
                  </div>
                  <div className="phone-wrap">
                    <p className="form-label">Phone Number*</p>
                    <TextInput
                      color="#352269"
                      backgroundColor="white"
                      fullwidth
                      variant="fill"
                      name="compactOne"
                      type="number"
                      value={phone}
                      note={phoneError}
                      handlers={{
                        onChange: (v) => handlePhoneChange(v),
                      }}
                    />
                  </div>

                  <div className="schedule-content">
                    <h4>Schedule an appointment</h4>
                    <p>
                      Select your preferred day and time to connect with a home
                      consultant. For same day and next day appointments, please
                      call the {formatDealerName(dealer?.dealerName)} at{' '}
                      <a
                        className="phone-link"
                        href={`tel:${dealer?.phoneNumber}`}
                      >
                        {formatPhoneNumberFromNumber(dealer?.phoneNumber)}
                      </a>
                    </p>
                  </div>
                  <div className="appointment-wrap">
                    <div className="appointment-column">
                      <p className="label">optional</p>
                      <DatePicker
                        placeholderText="Preferred Date"
                        selected={apptDate.value}
                        onChange={(date) =>
                          setApptDate({
                            value: date,
                            error: null,
                          })
                        }
                        dateFormat="MM/dd/yyyy"
                        filterDate={isSelectableScheduleVisitDate}
                        className="date-picker"
                        customInput={<DatepickerCustomInput />}
                      />
                    </div>
                    <div className="appointment-column">
                      <p className="label">optional</p>
                      <DropDownList
                        automationId="plannerDDList"
                        label="Preferred Time"
                        disabled={false}
                        errorMessage={apptTime.error}
                        id="flavor-drop-down-error"
                        items={[
                          {
                            text: '--Please choose an option--',
                            value: '',
                          },
                          { text: '9AM - 10AM', value: '9:00' },
                          { text: '10AM - 11AM', value: '10:00' },
                          { text: '11AM - 12PM', value: '11:00' },
                          { text: '12PM - 1PM', value: '12:00' },
                          { text: '1PM - 2PM', value: '13:00' },
                          { text: '2PM - 3PM', value: '14:00' },
                          { text: '3PM - 4PM', value: '15:00' },
                          { text: '4PM - 5PM', value: '16:00' },
                        ]}
                        onChange={(item) => {
                          setApptTime({ value: item.value, error: null });
                        }}
                        selectedItem={apptTime.value}
                        selectedValue={apptTime.value}
                        showClearIcon={false}
                      />
                    </div>
                  </div>

                  <Button
                    componentProps={{ onClick: saveForm }}
                    fullwidth={true}
                    // disabled={submitDisabled}
                  >
                    {submissionLoading ? 'Saving...' : 'GET IN TOUCH'}
                  </Button>
                  {formError && <p className="formError">{formError}</p>}
                  <div className="caption-wrap">
                    <span className="caption">
                      By clicking “Get In Touch,” you are signing this
                      disclosure, in which you authorize Clayton Homes and its
                      service providers to send you marketing text messages and
                      telephone calls using automated dialing technology to the
                      mobile number you provided in this form. Consent not
                      required for purchase. See our Terms & Conditions, which
                      includes opt-out instructions. Additionally you agree to
                      our{' '}
                      <a href="/legal/" target="_blank">
                        Terms & Conditions
                      </a>{' '}
                      and{' '}
                      <a
                        href="https://www.claytonhomes.com/privacy/"
                        target="_blank"
                      >
                        Privacy Policy
                      </a>
                      .
                    </span>
                  </div>
                </form>
              }
            />
          )}
          {(submissionStored || formSubmitted) && (
            <CTAPlannerCard
              className=""
              accentImg={{
                src: completedFormIcon,
                alt: 'completed planner icon',
              }}
              componentsProps={{
                Chip: {
                  color: '#352269',
                  background: 'white',
                },
              }}
              heading={'Thank you for submitting your planner details!'}
              description={
                <>
                  <Typography
                    color="white"
                    componentsProps={{
                      Root: {
                        style: {},
                      },
                    }}
                  >
                    Thank you for submitting your planner details. A home
                    consultant will contact you within 2 business days. Feel
                    free to continue shopping and refining your planner details.
                    If you have questions, reach out to your home consultant any
                    time at{' '}
                    <a
                      className="phone-link-thank-you"
                      href={`tel:${dealer?.phoneNumber}`}
                    >
                      {formatPhoneNumberFromNumber(dealer?.phoneNumber)}
                    </a>
                    .
                  </Typography>
                  <br />
                  <Link
                    className="cta-button"
                    to={{
                      pathname: '/portal/homes-for-you',
                      state: { dealer, homes },
                    }}
                    onClick={() => {
                      fireSegmentEvent('CTA Clicked', {
                        isNav: false,
                        type: 'button',
                        text: 'Shop Your Preferences',
                        eventContext: 'portal_planner_form_submission_cta',
                      });
                    }}
                  >
                    SHOP YOUR PREFERENCES
                  </Link>
                </>
              }
              chip="You've completed your planner!"
              backgroundColor="#352269"
            />
          )}
        </div>
      </div>
    </PlannerFormStyles>
  );
};

export default PlannerForm;
